import { r } from '@/plugins/resource/resource'
import { queryPostfix, prefixAPI } from '@/plugins/resource/api'

const MODEL = 'geo'
const MODEL_PHONES = 'phone-codes'

const m = postfix => `/${MODEL}/${postfix}`

export const geoApi = {
  citiesList: r(queryPostfix('/cities/list/', ['search', 'region', 'exact_search']), MODEL),
  regionsList: r(queryPostfix('/regions/list/', ['search', 'country']), MODEL),
  subregionsList: r(queryPostfix('/subregions/list/', ['search', 'country', 'region']), MODEL),
  countriesList: r(queryPostfix('/countries/list/', ['search']), MODEL),
}

export const GEO_COUNTRIES_LIST_URL: string = prefixAPI('/countries/list/{?search,limit,offset}', MODEL)
export const GEO_REGIONS_LIST_URL: string = prefixAPI('/regions/list/{?search,country,limit,offset}', MODEL)
export const GEO_SUBREGIONS_LIST_URL: string = prefixAPI('/subregions/list/{?search,country,region,limit,offset}', MODEL)
export const GEO_CITIES_LIST_URL: string = prefixAPI('/cities/list/{?search,country,region,subregion,limit,offset}', MODEL)
export const GEO_METRO_LIST_URL = prefixAPI('/metro/list/{?search,city,limit,offset}', MODEL)
export const GEO_DISTRICTS_LIST_URL = prefixAPI('/districts/list/{?search,city,limit,offset}', MODEL)

export const countriesList = r(queryPostfix('/list/', ['search']), MODEL_PHONES)
export const citiesList = r(queryPostfix('/cities/list/', ['search']), MODEL)
export const citiesFeaturesList = r(queryPostfix('/cities/featured/list/', ['search']), MODEL)
